import { render } from "./DataCleanupComponent.vue?vue&type=template&id=030c4d68&scoped=true&ts=true"
import script from "./DataCleanupComponent.vue?vue&type=script&lang=ts"
export * from "./DataCleanupComponent.vue?vue&type=script&lang=ts"

import "./DataCleanupComponent.vue?vue&type=style&index=0&id=030c4d68&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030c4d68"]])

export default __exports__